import React from 'react';
import { Autocomplete, TextField, createFilterOptions } from '@mui/material';

type DetranOption = {
  id: string;
  description: string;
  external_code?: string;
};

const filterOptions = createFilterOptions<DetranOption>({
  stringify: (option) => `${option.description} ${option.external_code || ''}`,
});

export default function DetranSelect({
  options,
  value,
  disabled,
  onChange,
}: {
  options: DetranOption[];
  value: string;
  disabled: boolean;
  onChange: (id: string) => void;
}) {
  const sortedOptions = React.useMemo(
    () =>
      [...options].sort((a, b) =>
        a.description.localeCompare(b.description, 'pt-BR')
      ),
    [options]
  );

  return (
    <Autocomplete<DetranOption, false, boolean, false>
      fullWidth
      size="small"
      disableClearable
      disabled={disabled}
      options={sortedOptions}
      value={options.find((option) => option.id === value) || null}
      getOptionLabel={(option) => option.description}
      isOptionEqualToValue={(option, selected) => option.id === selected.id}
      filterOptions={filterOptions}
      onChange={(_, option) => {
        if (option) onChange(option.id);
      }}
      noOptionsText="Nenhum Detran encontrado"
      openText="Selecionar Detran"
      closeText="Fechar opções"
      renderInput={(params) => (
        <TextField
          {...params}
          label="Detran"
          placeholder="Buscar por nome ou UF"
        />
      )}
    />
  );
}
